import { filtersAtom, refreshGridDataAtom } from "Atoms/WorkAssignmentGridAtoms";
import axios, { AxiosError, AxiosResponse } from "axios";
import Config from "config";
import { useAtom } from "jotai";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { Assignments } from "types/Assignments";
import Problem from "types/problem";
import { SnackbarContext } from "../components/Common/SnackbarProvider";
import { useContext } from "react";
import { t } from "i18next";


const useAddAssignments = (teamId: number) => {
    const { setSnackbar } = useContext(SnackbarContext);
    const queryClient = useQueryClient();
    const [filters] = useAtom(filtersAtom);
    const [refreshGridCount, setRefreshGridCount] = useAtom(refreshGridDataAtom);
    const nav = useNavigate();
    return useMutation<AxiosResponse, AxiosError<Problem>, Assignments>(
      (h) => axios.post(`${Config.baseApiUrl}/assignment`, h),
      {
        onSuccess: () => {
          const count = refreshGridCount + 1;
          setSnackbar(true,t('AssignToastMessage'),"success");
          setRefreshGridCount(count)
          queryClient.invalidateQueries(["filters", filters]);
          queryClient.invalidateQueries(["Team", teamId]);
          nav(`/workassignment`);
        },
      }
    );
  };

const useDeleteAssignments = () => {
  const { setSnackbar } = useContext(SnackbarContext);
  const queryClient = useQueryClient();
  const [filters] = useAtom(filtersAtom);
  const [refreshGridCount, setRefreshGridCount] = useAtom(refreshGridDataAtom);
  const nav = useNavigate();  
  return useMutation<AxiosResponse, AxiosError<Problem>, Assignments>(
    (Assignments) =>
      axios.patch(`${Config.baseApiUrl}/userAssignedOperations`, Assignments),
      {
        onSuccess: () => {
          const count = refreshGridCount + 1;
          setSnackbar(true,t('UnassignToastMessage'),"success");
          setRefreshGridCount(count)
          queryClient.invalidateQueries(["filters", filters]);
          nav(`/workassignment`);
        }, 
        onError: (error) => {
          const errorMessage =
            error.response?.data?.title || t("UnassignErrorToastMessage");
          setSnackbar(true, errorMessage, "error");
        },
      }
    );
};
  

export { useAddAssignments,
         useDeleteAssignments
       };